import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/does-tms-require-maintenance")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "what-happens-after-saint-tms" },
      statusCode: 301,
    });
  },
});
